import { render, staticRenderFns } from "./restrictedDetail.vue?vue&type=template&id=f2e75b7c&scoped=true"
import script from "./restrictedDetail.vue?vue&type=script&lang=js"
export * from "./restrictedDetail.vue?vue&type=script&lang=js"
import style0 from "./restrictedDetail.vue?vue&type=style&index=0&id=f2e75b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e75b7c",
  null
  
)

export default component.exports